import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-ship',
  templateUrl: './delete-ship.component.html',
  styleUrls: ['./delete-ship.component.css']
})
export class DeleteShipComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
